import { SECTION_IDS } from "./content";

export const Mission = () => (
  <section
    id={SECTION_IDS.mission}
    className="dc-section border-b border-white/[.07]"
  >
    <div className="dc-shell">
      <h2 className="m-0 max-w-[20ch] text-[clamp(32px,5.4vw,88px)] font-bold leading-[.98] tracking-[-.042em] text-balance">
        We turn decades of Earth data into actionable intelligence, at the speed
        your decisions demand.
      </h2>

      <div className="mt-[clamp(48px,6vw,84px)] flex flex-wrap gap-[clamp(28px,4vw,80px)]">
        <p className="m-0 min-w-0 flex-[1_1_380px] text-[clamp(16px,1.4vw,19px)] leading-[1.75] text-mist-2">
          We understand both the science and the engineering behind large-scale
          Earth data: how landscapes behave, and how to interrogate large amounts
          of information.
        </p>
        <p className="m-0 min-w-0 flex-[1_1_380px] text-[clamp(16px,1.4vw,19px)] leading-[1.75] text-mist-2">
          Our clients are government agencies, research institutions, industry
          bodies and private landholders, working across water, fire, forests,
          biodiversity and property. We are scientists, but our value is measured
          by what our clients achieve, not by what we publish.
        </p>
      </div>

      <p className="mt-[clamp(48px,6vw,88px)] mb-0 max-w-[30ch] text-[clamp(22px,2.8vw,42px)] font-medium leading-[1.22] tracking-[-.028em] text-mint">
        You understand your problem; we understand the data. We work together to
        find the answers.
      </p>
    </div>
  </section>
);
